<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <case-form
      :isLoading="isLoading"
      :onSubmit="onSubmit">
    </case-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import CaseForm from './CaseForm.vue';
import services from '../../../services';

const { biobankRegistry } = services;
const { caseService } = biobankRegistry;

export default {
  name: 'case-create',
  components: {
    CaseForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Create Case Number',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        const { _id: id } = await caseService.create({ caseNumber: data });

        this.$snackbar.showOk({ text: 'Successfully created Case Number!' });

        this.$router.replace({ name: 'bcase.edit', params: { id } });
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
  },
};
</script>
